export const DDC_SLIDESHOW_PAGERCLICK = 'ddc.slideshow.pagerClick';

function pagerClick(
	{
		DDC: {
			dataLayer: {
				page: {
					pageInfo: { pageName }
				}
			}
		}
	},
	_event,
	eventData
) {
	return {
		eventType: DDC_SLIDESHOW_PAGERCLICK,
		eventData: {
			...eventData,
			pageName
		}
	};
}

export default pagerClick;
